<template>
    <CompassDialog
        :visible.sync="showModal"
        size="small"
        :title="$t.__('popups.RemoveTrustedDevice.delete_your_trusted_device')"
        class="remove-trusted-device"
        @closed="close"
    >
        <template slot="default">
            <div class="dialog__default">
                <div class="device typographies-paragraph-medium-bold">
                    {{ trustedDevice.device }} - {{ trustedDevice.browser }}
                </div>

                <p class="typographies-paragraph-medium-semibold m-0 mb-3">
                    {{
                        $l10n.__(
                            'En supprimant cet appareil de confiance, un code de sécurité vous sera à nouveau demandé à chaque connexion sur cet appareil.',
                        )
                    }}
                </p>

                <el-checkbox v-model="disconnect">
                    {{ $l10n.__('Me déconnecter immédiatement de cet appareil') }}
                </el-checkbox>
            </div>
        </template>
        <template slot="footer">
            <div class="dialog__footer">
                <CompassButton
                    :label="$t.__('common.actions.cancel')"
                    type="secondary"
                    @click="close"
                />
                <CompassButton
                    :label="$t.__('popups.RemoveTrustedDevice.delete_trusted_device')"
                    type="primary-destructive"
                    :loading="loading"
                    class="ml-2"
                    @click="save()"
                />
            </div>
        </template>
    </CompassDialog>
</template>

<script>
export default {
    props: {
        trustedDevice: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            showModal: true,
            disconnect: false,
            loading: false,
        };
    },
    methods: {
        save() {
            ApiClient.del(
                `/settings/two-factor-authentication/user/trusted-devices/${this.trustedDevice.id}`,
                {},
                {
                    disconnect: this.disconnect,
                },
            )
                .then(() => {
                    this.$trigger('2fa:updateUserSettings');
                    Push.success(this.$l10n.__('Appareil de confiance supprimé'));
                })
                .catch((error) => {
                    Push.error(this.$l10n.__('Une erreur est survenue'));
                });
            this.$emit('close');
        },
        close() {
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@sellsy/styleguide/src/_variables';

.remove-trusted-device {
    .dialog {
        &__default {
            padding-bottom: 24px;
        }

        &__footer {
            display: flex;
            justify-content: flex-end;
            padding: 0 32px 24px 32px;
        }
    }

    &::v-deep {
        .el-checkbox {
            align-items: center;
            display: flex;
            line-height: 20px;

            &__inner {
                border-radius: 4px;
            }

            &__label {
                line-height: 20px;
            }

            .el-checkbox__input {
                padding-top: 0;
            }
        }
    }

    .device {
        border: 1px solid $gray-40;
        border-radius: 4px;
        font-weight: 700;
        margin: 0 0 16px;
        padding: 16px;
    }
}
</style>
